import { takeLatest, call, put, all } from "redux-saga/effects";
import Cookies from "js-cookie";
import { db } from "helpers/firebase/firebaseConfig";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import {
  fetchProviderInvoicesSuccess,
  fetchProviderInvoicesFailure,
} from "./actions";
import { FETCH_PROVIDER_INVOICES_REQUEST } from "./actionTypes";

// Fetch provider ERP invoices by resolving provider doc ID from auth cookie
async function fetchProviderInvoices() {
  try {
    // Try multiple cookie names
    const authId =
      Cookies.get("usersessionId") ||
      Cookies.get("userId") ||
      Cookies.get("providerId");

    if (!authId) throw new Error("No provider session found");

    // Resolve provider Firestore doc by various possible fields
    let providerDoc = null;

    // Try service_provider_auth_id
    let provQ = query(
      collection(db, "service_providers"),
      where("service_provider_auth_id", "==", authId)
    );
    let provSnap = await getDocs(provQ);
    if (!provSnap.empty) {
      providerDoc = provSnap.docs[0];
    }

    // Try auth_id if not found
    if (!providerDoc) {
      provQ = query(
        collection(db, "service_providers"),
        where("auth_id", "==", authId)
      );
      provSnap = await getDocs(provQ);
      if (!provSnap.empty) {
        providerDoc = provSnap.docs[0];
      }
    }

    // Try user_id if not found
    if (!providerDoc) {
      provQ = query(
        collection(db, "service_providers"),
        where("user_id", "==", authId)
      );
      provSnap = await getDocs(provQ);
      if (!provSnap.empty) {
        providerDoc = provSnap.docs[0];
      }
    }

    // Fallback: treat cookie as provider doc ID
    if (!providerDoc) {
      const directSnap = await getDoc(doc(db, "service_providers", authId));
      if (directSnap.exists()) {
        providerDoc = directSnap;
      }
    }

    if (!providerDoc) throw new Error("Provider not found");

    const providerId = providerDoc.id;

    // Fetch provider ERP invoices linked to provider doc id
    const erpQ = query(
      collection(db, "provider_erp"),
      where("service_provider_id", "==", providerId)
    );
    const erpSnap = await getDocs(erpQ);

    const items = erpSnap.docs.map(d => ({
      id: d.id,
      ...d.data(),
    }));

    // Sort by created_at desc if present (ISO string)
    items.sort((a, b) => {
      const ad = new Date(a.created_at || 0).getTime();
      const bd = new Date(b.created_at || 0).getTime();
      return bd - ad;
    });

    return items;
  } catch (err) {
    throw err;
  }
}

function* handleFetchProviderInvoices() {
  try {
    const items = yield call(fetchProviderInvoices);
    yield put(fetchProviderInvoicesSuccess(items));
  } catch (error) {
    yield put(fetchProviderInvoicesFailure(error.message));
  }
}

export default function* invoicesRootSaga() {
  yield all([takeLatest(FETCH_PROVIDER_INVOICES_REQUEST, handleFetchProviderInvoices)]);
}